import React from "react";
import _ from "lodash";

const bucket = (items: any[], n: number) => {
  return items.reduce(
    (acc, item, index) => {
      acc[index % n].push(item);
      return acc;
    },
    Array.from({ length: n }, () => []),
  );
};

export function Masonry<T>(props: {
  items: T[];
  fn: (item: T, index: number) => JSX.Element;
}) {
  return (
    <>
      <div className="md:hidden w-full space-y-1">
        {props.items.map(props.fn)}
      </div>
      <div className="hidden md:flex xl:hidden w-full space-x-1">
        {bucket(props.items, 2).map((chunk, i) => (
          <div key={`mesnr-${i}`} className="w-1/2 space-y-1">
            {chunk.map(props.fn)}
          </div>
        ))}
      </div>
      <div className="hidden xl:flex w-full space-x-1 ">
        {bucket(props.items, 3).map((chunk, i) => (
          <div key={`mesnr-${i}`} className="w-1/3 space-y-1">
            {chunk.map(props.fn)}
          </div>
        ))}
      </div>
    </>
  );
}
